module.exports = __webpack_public_path__ + "static/media/radio-0-hover.a4a1c67d.svg";